import { closeCurrentWebView } from "@/utils/native/interaction";
import { getThemeBgColor } from "@/utils/project";

export default [
  {
    path: "/wt-bounty-desc",
    name: "BountyDesc",
    meta: {
      title: "奖励说明",
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "bounty" */ "@/views/mine/bounty/BountyDesc.vue"
      )
  },
  {
    path: "/wt-bounty-detail",
    name: "BountyDetail",
    meta: {
      title: "积分明细",
      showBountyTitle: true,
      showBountyDetail: true,
      customBackFn: closeCurrentWebView,
      theme: "transparent-dark",
      keepAlive: true,
      background: getThemeBgColor //"linear-gradient(to right, #FFD700, #FFCA00)"
    },
    component: () =>
      import(
        /* webpackChunkName: "bounty" */ "@/views/mine/bounty/BountyDetail.vue"
      )
  }
];
